<template>
  <div class="second_section">
    <div class="second_section_container">
      <h1>产品介绍</h1>

      <!-- Nav pills -->
      <div class="our_pro_title">
        <ul class="nav nav-pills">
          <li class="active nav-item">
            <a class="tab-link" href="#tab-1" data-toggle="tab">
              <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
                <title>yuyin-1</title>
                <path
                  d="M103.63,7.27A96.37,96.37,0,1,0,200,103.63,96.36,96.36,0,0,0,103.63,7.27m0,13.76A82.6,82.6,0,1,1,21,103.63,82.69,82.69,0,0,1,103.63,21M121.53,156a6.9,6.9,0,0,1-4.87-11.76,57.36,57.36,0,0,0,0-81.12,6.89,6.89,0,0,1,9.73-9.73,71.11,71.11,0,0,1,0,100.59,6.87,6.87,0,0,1-4.86,2M97.47,136.47a6.89,6.89,0,0,1-4.87-11.75,29.87,29.87,0,0,0,0-42.19,6.89,6.89,0,0,1,9.74-9.72,43.66,43.66,0,0,1,0,61.65,6.89,6.89,0,0,1-4.87,2M82.59,110.12a9.18,9.18,0,1,1-.11-12.87,9.2,9.2,0,0,1,.11,12.87"
                  transform="translate(0)"
                />
                <path
                  d="M96.37,0a96.37,96.37,0,1,0,96.36,96.37A96.36,96.36,0,0,0,96.37,0m0,13.77a82.6,82.6,0,1,1-82.6,82.6,82.69,82.69,0,0,1,82.6-82.6m17.89,134.91a6.89,6.89,0,0,1-4.86-11.75,57.37,57.37,0,0,0,0-81.12,6.89,6.89,0,0,1,9.74-9.73,71.12,71.12,0,0,1,0,100.58,6.88,6.88,0,0,1-4.87,2M90.2,129.21a6.9,6.9,0,0,1-4.86-11.76,29.88,29.88,0,0,0,0-42.18,6.89,6.89,0,0,1,9.73-9.73,43.64,43.64,0,0,1,0,61.65,6.88,6.88,0,0,1-4.86,2M75.32,102.85A9.18,9.18,0,1,1,75.21,90a9.15,9.15,0,0,1,.11,12.86"
                  transform="translate(0)"
                />
              </svg>
              <p>语音压缩</p>
            </a>
          </li>
          <li class="nav-item">
            <a class="tab-link" href="#tab-2" data-toggle="tab">
              <!-- <img src="../../assets/icon/tupian-1.webp" alt="" /> -->
              <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 199.67 172.15">
                <title>tupian-1</title>
                <path
                  d="M7.06,39A18.34,18.34,0,0,1,25.41,20.65h156A18.33,18.33,0,0,1,199.73,39V167.45a18.35,18.35,0,0,1-18.35,18.35h-156A18.35,18.35,0,0,1,7.06,167.45ZM25.41,152.9v14.55h156V153.63L113.89,102,92,127.55a9.18,9.18,0,0,1-12.7,1.19L62.8,115.52Zm156-22.37V39h-156v88L55.62,96.74a9.17,9.17,0,0,1,12.22-.68l16,12.81L105.6,83.49a9.17,9.17,0,0,1,12.54-1.31ZM43.76,68.82A16.06,16.06,0,1,1,59.82,84.87,16.06,16.06,0,0,1,43.76,68.82Zm0,0"
                  transform="translate(-0.06 -13.65)"
                />
                <path
                  d="M.06,32A18.34,18.34,0,0,1,18.41,13.65h156A18.33,18.33,0,0,1,192.73,32V160.45a18.35,18.35,0,0,1-18.35,18.35h-156A18.35,18.35,0,0,1,.06,160.45ZM18.41,145.9v14.55h156V146.63L106.89,95,85,120.55a9.18,9.18,0,0,1-12.7,1.19L55.8,108.52Zm156-22.37V32h-156v88L48.62,89.74a9.17,9.17,0,0,1,12.22-.68l16,12.81L98.6,76.49a9.17,9.17,0,0,1,12.54-1.31ZM36.76,61.82A16.06,16.06,0,1,1,52.82,77.87,16.06,16.06,0,0,1,36.76,61.82Zm0,0"
                  transform="translate(-0.06 -13.65)"
                />
              </svg>
              <p>图片压缩</p>
            </a>
          </li>
          <li class="nav-item">
            <a class="tab-link" href="#tab-3" data-toggle="tab">
              <!-- <img src="../../assets/icon/duanbaowen-1.webp" alt="" /> -->
              <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 185.89 199.73">
                <title>duanbaowen-1</title>
                <path
                  d="M137.05,192.26a7.54,7.54,0,0,1-7.6,7.61H71.32a7.54,7.54,0,0,1-7.6-7.61,7.83,7.83,0,0,1,7.6-7.6h21V114A19,19,0,0,1,81.6,97,18.42,18.42,0,0,1,99.94,78.68,18.71,18.71,0,0,1,118.27,97a19,19,0,0,1-10.73,17v70.65h21c4.91,0,8.49,3.58,8.49,7.6ZM100.38,7.13A89.89,89.89,0,0,0,10.5,97a89,89,0,0,0,26.38,63.5,7.59,7.59,0,1,0,10.74-10.74,74.3,74.3,0,0,1,52.32-127c40.69,0,74.23,33.54,74.23,74.24a74.14,74.14,0,0,1-21.91,52.76,7.31,7.31,0,0,0,0,10.74,7.57,7.57,0,0,0,10.73,0A89,89,0,0,0,189.37,97c.9-49.64-39.35-89.89-89-89.89Zm0,37.12A52.86,52.86,0,0,0,47.62,97a51,51,0,0,0,15.65,37.11c3.13,3.13,8,3.13,10.73,0,3.13-3.13,3.13-8,0-10.73A37.2,37.2,0,1,1,137.5,97a38.79,38.79,0,0,1-10.73,26.38c-3.13,3.13-3.13,8,0,10.73a7.54,7.54,0,0,0,10.73,0,52.49,52.49,0,0,0-37.12-89.88Zm0,0"
                  transform="translate(-3.5 -0.13)"
                />
                <path
                  d="M130.05,185.26a7.54,7.54,0,0,1-7.6,7.61H64.32a7.54,7.54,0,0,1-7.6-7.61,7.83,7.83,0,0,1,7.6-7.6h21V107A19,19,0,0,1,74.6,90,18.42,18.42,0,0,1,92.94,71.68,18.71,18.71,0,0,1,111.27,90a19,19,0,0,1-10.73,17v70.65h21c4.91,0,8.49,3.58,8.49,7.6ZM93.38.13A89.89,89.89,0,0,0,3.5,90a89,89,0,0,0,26.38,63.5,7.31,7.31,0,0,0,10.74,0,7.31,7.31,0,0,0,0-10.74,74.3,74.3,0,0,1,52.32-127c40.69,0,74.23,33.54,74.23,74.24a74.14,74.14,0,0,1-21.91,52.76,7.31,7.31,0,0,0,0,10.74,7.57,7.57,0,0,0,10.73,0A89,89,0,0,0,182.37,90C183.27,40.38,143,.13,93.38.13Zm0,37.12A52.86,52.86,0,0,0,40.62,90a51,51,0,0,0,15.65,37.11c3.13,3.13,8,3.13,10.73,0,3.13-3.13,3.13-8,0-10.73A37.2,37.2,0,1,1,130.5,90a38.79,38.79,0,0,1-10.73,26.38c-3.13,3.13-3.13,8,0,10.73a7.54,7.54,0,0,0,10.73,0A52.49,52.49,0,0,0,93.38,37.25Zm0,0"
                  transform="translate(-3.5 -0.13)"
                />
              </svg>
              <p>短报文接收服务</p>
            </a>
          </li>
          <li class="nav-item">
            <a class="tab-link" href="#tab-4" data-toggle="tab">
              <!-- <img src="../../assets/icon/SDK-1.webp" alt="" /> -->
              <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 199.67 164.15">
                <title>SDK-1</title>
                <path
                  d="M7,38.89A18.34,18.34,0,0,1,25.35,20.54h156a18.33,18.33,0,0,1,18.35,18.35V159.34a18.35,18.35,0,0,1-18.35,18.35h-156A18.35,18.35,0,0,1,7,159.34Zm174.32,91.53V38.89h-156V159.34h156V130.42ZM43.7,68.71"
                  transform="translate(0 -13.54)"
                />
                <rect class="cls-1" x="89.52" y="112.22" width="75.2" height="17.04" rx="8.52" />
                <rect
                  x="37.39"
                  y="78.08"
                  width="57.66"
                  height="17.04"
                  rx="8.52"
                  transform="translate(73.01 -35.74) rotate(40.98)"
                />
                <rect
                  x="37.05"
                  y="104.68"
                  width="57.66"
                  height="17.04"
                  rx="8.52"
                  transform="translate(189.41 143.19) rotate(139.61)"
                />
                <path
                  d="M156.27,71.33V59.79H144.48L135.69,51l-9.33,9H114.7V71.79l-8.93,8.92L115,90V101.6h11.88l9.27,9.26,9.11-9.1h11.32V89.58l8.95-9ZM152,87.81V97.3h-8.82l-7.1,7.1-7.22-7.22h-9.26V88.12l-7.22-7.21,7-7V64.72h9.09l7.27-7,6.85,6.85h9.19v9L159,80.84Z"
                  transform="translate(0 -13.54)"
                />
                <path
                  d="M135.67,70.14a10.74,10.74,0,1,0,10.74,10.74A10.74,10.74,0,0,0,135.67,70.14Zm0,16.14a5.4,5.4,0,1,1,5.4-5.4A5.4,5.4,0,0,1,135.67,86.28Z"
                  transform="translate(0 -13.54)"
                />
                <path
                  d="M0,31.89A18.34,18.34,0,0,1,18.35,13.54h156a18.33,18.33,0,0,1,18.35,18.35V152.34a18.35,18.35,0,0,1-18.35,18.35h-156A18.35,18.35,0,0,1,0,152.34Zm174.32,91.53V31.89h-156V152.34h156V123.42ZM36.7,61.71"
                  transform="translate(0 -13.54)"
                />
                <rect class="cls-2" x="82.52" y="105.22" width="75.2" height="17.04" rx="8.52" />
                <rect
                  x="30.39"
                  y="71.08"
                  width="57.66"
                  height="17.04"
                  rx="8.52"
                  transform="translate(66.7 -32.87) rotate(40.98)"
                />
                <rect
                  x="30.05"
                  y="97.68"
                  width="57.66"
                  height="17.04"
                  rx="8.52"
                  transform="translate(172.54 135.4) rotate(139.61)"
                />
                <path
                  d="M149.27,64.33V52.79H137.48L128.69,44l-9.33,9H107.7V64.79l-8.93,8.92L108,83V94.6h11.88l9.27,9.26,9.11-9.1h11.32V82.58l8.95-9ZM145,80.81V90.3h-8.82l-7.1,7.1-7.22-7.22h-9.26V81.12l-7.22-7.21,7-7V57.72h9.09l7.27-7,6.85,6.85h9.19v9L152,73.84Z"
                  transform="translate(0 -13.54)"
                />
                <path
                  d="M128.67,63.14a10.74,10.74,0,1,0,10.74,10.74A10.74,10.74,0,0,0,128.67,63.14Zm0,16.14a5.4,5.4,0,1,1,5.4-5.4A5.4,5.4,0,0,1,128.67,79.28Z"
                  transform="translate(0 -13.54)"
                />
              </svg>
              <p>Android/IOS SDK</p>
            </a>
          </li>
          <!-- <li class="nav-item">
            <a class="tab-link" href="#tab-5" data-toggle="tab">
              <svg id="图层_1" data-name="图层 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 163.97">
                <title>ka-1</title>
                <path
                  d="M7.3,53.31A19.15,19.15,0,0,1,26.45,34.16h154.4A19.15,19.15,0,0,1,200,53.31V171.68a19.15,19.15,0,0,1-19.15,19.15H26.45A19.15,19.15,0,0,1,7.3,171.68Zm173.55,88.2V53.31H26.45V171.68h154.4V141.51ZM45.6,84.42"
                  transform="translate(0 -26.86)"
                />
                <rect class="cls-1" x="107.49" y="110.84" width="56.72" height="17.78" rx="8.52" />
                <rect class="cls-1" x="19.03" y="41.72" width="171.29" height="17.78" />
                <path
                  d="M0,46A19.14,19.14,0,0,1,19.15,26.86h154.4A19.14,19.14,0,0,1,192.7,46V164.38a19.15,19.15,0,0,1-19.15,19.15H19.15A19.15,19.15,0,0,1,0,164.38Zm173.55,88.2V46H19.15V164.38h154.4V134.2ZM38.29,77.12"
                  transform="translate(0 -26.86)"
                />
                <rect class="cls-2" x="100.19" y="103.53" width="56.72" height="17.78" rx="8.52" />
                <rect class="cls-2" x="11.73" y="34.41" width="171.29" height="17.78" />
              </svg>
              <p>北斗三号短报文卡申请</p>
            </a>
          </li> -->
        </ul>
      </div>

      <!-- Tab panes -->
      <div class="tab-content tab-content-blue well">
        <div class="tab-pane active" id="tab-1">
          <div class="pane_content">
            <div class="our_pro_con">
              <p>语音压缩算法</p>
              <ul>
                <li>
                  <span>极低256bps码率</span>
                </li>
                <li>
                  <span>北斗三五级卡可发56秒语音</span>
                </li>
                <li>
                  <span>压缩后清晰听清音调音色</span>
                </li>
                <li>
                  <span>北斗短报文三号应用新模式</span>
                </li>
              </ul>
              <div class="our_pro_detail">
                <router-link to="/product/compress">了解详情</router-link>
              </div>
              <!-- <div class="our_pro_animation b-lazy"></div> -->
            </div>
            <div class="gif-wrapper">
              <img src="../../assets/home/gif1.gif" alt="语音压缩" />
            </div>
          </div>
        </div>
        <div class="tab-pane tab-content-blue1" id="tab-2">
          <div class="pane_content">
            <div class="our_pro_con picture-compress">
              <p>渐进式图像压缩算法</p>
              <ul>
                <li>
                  <span>最大1000倍压缩比</span>
                </li>
                <li>
                  <span>支持图片层叠切割</span>
                </li>
                <li>
                  <span>适合窄带宽图像传输</span>
                </li>
                <li>
                  <span>适合抗长时延图像传输</span>
                </li>
                <li>
                  <span>支持jpg和j2p两种格式</span>
                </li>
              </ul>
              <div class="our_pro_detail">
                <a href="/product/pic" >了解详情</a>
              </div>
              <!-- <div class="our_pro_animation b-lazy"></div> -->
            </div>
            <div class="gif-wrapper">
              <img src="../../assets/home/gif2.gif" alt="图片压缩" />
            </div>
          </div>
        </div>
        <div class="tab-pane tab-content-black" id="tab-3">
          <div class="pane_content">
            <div class="our_pro_con">
              <p>短报文接收服务</p>
              <ul>
                <li>
                  <span>客户无需部署本地指挥机</span>
                </li>
                <li>
                  <span>云端数据推送或主动查询</span>
                </li>
                <li>
                  <span>数据云端最长保存3年</span>
                </li>
                <li>
                  <span>提供sdk支持快捷开发</span>
                </li>
              </ul>
              <div class="our_pro_detail">
                <router-link to="/product/operate">了解详情</router-link>
              </div>
              <!-- <div class="our_pro_animation b-lazy"></div> -->
            </div>
            <div class="gif-wrapper">
              <img src="../../assets/home/gif3.gif" alt="短报文服务" />
            </div>
          </div>
        </div>
        <div class="tab-pane tab-content-black" id="tab-4">
          <div class="pane_content">
            <div class="our_pro_con">
              <p>北斗SDK产品</p>
              <ul>
                <li>
                  <span>安卓/苹果/PC端均有SDK</span>
                </li>
                <li>
                  <span>配套手持/车载/船载各端</span>
                </li>
                <li>
                  <span>提供企业级专业技术支持</span>
                </li>
              </ul>
              <div class="our_pro_detail">
                <router-link to="/product/sdk">了解详情</router-link>
              </div>
              <!-- <div class="our_pro_animation b-lazy"></div> -->
            </div>
            <div class="gif-wrapper">
              <img src="../../assets/home/gif4.gif" alt="北斗SDK产品" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.second_section {
  width: 100vw;
  .second_section_container {
    h1 {
      margin-top: 82px;
      font-size: 28px;
      font-weight: 400;
      color: #0d0e24;
      text-align: center;
      margin-bottom: 70px;
    }
    .our_pro_title {
      .nav {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .nav-item {
          // margin-right: 140px;
          position: relative;
          .tab-link {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-decoration: none;
            p {
              text-align: center;
              font-size: 14px;
              font-weight: 400;
              margin-bottom: 32px;
              color: #0d0e24;
            }
            svg {
              width: 32px;
              height: 32px;
              margin-bottom: 10px;
              fill: #929292;
            }
          }
        }
      }
    }

    .tab-content {
      height: 446px;
      position: relative;
      overflow: hidden;
      // background: #243045;
      .tab-pane {
        height: 446px;
        width: 100%;
        box-sizing: border-box;
        .pane_content {
          width: 1200px;
          height: 100%;
          margin: 0 auto;
          position: relative;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          .our_pro_con {
            // position: absolute;
            // top: 50%;
            // transform: translateY(-50%);
            p {
              font-size: 20px;
              color: #ffffff;
            }
            ul {
              position: relative;
              li {
                list-style: none;
                height: 36px;
                position: relative;
                white-space: nowrap;
                span {
                  font-size: 14px;
                  color: #fff;
                  height: 34px;
                  line-height: 34px;
                  margin-left: 34px;
                }
                &:before {
                  content: '';
                  display: inline-block;
                  position: absolute;
                  left: 0;
                  top: 50%;
                  margin-top: -4px;
                  width: 7px;
                  height: 7px;
                  background-color: #3d6eff;
                  border-radius: 50%;
                  margin-left: 3px;
                  vertical-align: middle;
                }
              }
              &:after {
                content: '';
                display: block;
                top: 17px;
                bottom: 15px;
                left: 46px;
                position: absolute;
                width: 1px;
                height: auto;
                background: rgba(0, 0, 0, 0.44);
                z-index: -1;
                padding: 5px 0;
              }
            }
          }
          // .picture-compress{
          //   margin-right: 300px;
          // }

          .gif-wrapper {
            img {
              max-width: 800px;
            }
          }
          .our_pro_detail {
            margin: 48px 0 0;
            width: 100px;
            height: 32px;
            border: 1px solid #fff;
            border-radius: 16px;
            color: #fff;
            text-align: center;
            line-height: 29px;
            a {
              text-decoration: none;
              color: #fff;
              cursor: pointer;
              width: 100px;
              height: 32px;
              display: block;
            }
          }
        }
      }
    }
    .tab-content-blue{
      background: #243045;
    }
    .tab-content-black{
      background-color: #293142;
    }
    .tab-content-blue1{
      background-color: #252e43;
    }
  }
}
.active {
  .tab-link {
    p {
      color: #4173fb !important;
    }
    svg {
      fill: #4173fb !important;
    }
  }
  &:after {
    content: '';
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-bottom-color: #22283b;
    z-index: 3;
    left: 50%;
    margin: -18px 0 0 -6px;
    position: absolute;
  }
}
</style>